import React, { useState, useEffect } from 'react';

import useLocales from '../../../../hooks/data/useLocales';

import { Logo } from '../../../../../static/icons/logo';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { Stack } from '../../../atoms/stack/Stack';
import { Close } from '../../../../../static/icons/close';

const ReferrerModal = ({ targetReferrer }) => {
  const [showModal, setShowModal] = useState(false);
  const { locale } = useLocales();

  useEffect(() => {
    // Check if user came from the target referrer
    const checkReferrer = () => {
      if (typeof window !== 'undefined') {
        const { referrer } = document;

        // Check both document.referrer and stored referrer
        const shouldShowModal =
          referrer.includes(targetReferrer) && locale === 'dk_DK';

        console.log('referrer: ' + referrer);
        console.log('locale: ' + locale);
        console.log('shouldShowModal: ' + shouldShowModal);

        // Only show modal once per session
        const hasShownModal = sessionStorage.getItem('referrerModalShown');

        if (shouldShowModal && !hasShownModal) {
          setShowModal(true);
        }
      }
    };

    const timer = setTimeout(checkReferrer, 500);
    return () => clearTimeout(timer);
  }, [targetReferrer, locale]);

  // Lock/unlock scroll when modal opens/closes
  useEffect(() => {
    if (showModal) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.style.overflow = originalStyle;
      };
    }

    return () => {};
  }, [showModal]);

  const closeModal = () => {
    sessionStorage.setItem('referrerModalShown', 'true');
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[99999]">
      <div className="flex items-center justify-center h-full">
        <div className="flex mx-2 bg-white max-w-2xl flex-col flex-1 md:my-20 rounded-[32px] sm:mx-4">
          <div className="relative flex flex-col px-5 py-8 gap-12">
            <button
              type="button"
              onClick={closeModal}
              aria-label="Close modal"
              className="absolute top-5 right-5 flex justify-center items-center w-12 h-12 border border-black rounded-xl global-hover"
            >
              <Close color="black" height={30} width={30} />
            </button>

            <Stack className="flex flex-1 gap-8 flex-col justify-center items-center sm:mx-4">
              <Logo color="black" width={150} height={100} />

              <Typography as="h3" fontVariant="h4">
                DigiMatcher er nu en del af BusinessWith!
              </Typography>

              <Typography fontVariant="h6">
                Du er blevet videresendt til BusinessWiths blog, hvor du fortsat
                kan finde guides og inspiration om it-systemer og
                digitalisering.
              </Typography>

              <Typography
                className="font-semibold"
                fontVariant="h6"
                textAlign="left"
              >
                Velkommen til – og god læsning!
              </Typography>

              <LinkButton
                label="Fortsätt till BusinessWith"
                onClick={closeModal}
                size="lg"
                textTransform="uppercase"
                className="w-fit bg-primary-500 mt-4"
              />
            </Stack>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferrerModal;
